import React from 'react';
import { Link } from 'react-router-dom';


const Escortguard = () => {
    return (
        <>
            {/* <!-- Breadcromb Area Start --> */}
            <section className="bleezy-breadcromb-area">
                <div className="breadcromb-top escort-header">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="breadcromb-top-text">
                                    <h2 className='banner-heading'>Escort Guard </h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="breadcromb-bottom">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="breadcromb-bottom-text">
                                    <ul>
                                        <li><Link to="/">home</Link></li>
                                        <li><a href="#"><i className="fa fa-long-arrow-right"></i></a></li>
                                        <li>Escort Guard</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- Breadcromb Area End --> */}
            <section class="bleezy-blog-page-area" style={{ paddingTop: '15px', paddingBottom: '15px' }}>
                <div class="container">
                    <div class="mid-title  mb-5 "><h2 class="heading-with-border"><strong>Escort Guard</strong></h2>
                        <p className="octo-para">
                            BPO’s or MNC’s or any other workplace where female employees are working till late evening or in night shifts, are mandatorily required to be provided with pick up and drop facility, with an escort guard in each vehicle, for the safety of female employees. As per the Shop and Establishment Act of various state, it is a mandatory requirement. For instance, as per Bombay Shop & Establishment Act, a female employee working beyond 9:30 PM till 7 AM must be provided with cab facility with escort guard in India.
                        </p>
                        <p className="octo-para sub-heading-m-t-15 sub-heading-m-b-15">In metro cities, it is not uncommon for female employees to work late at night, therefore, our escort security service in India is one of the most sought after service by the MNCs.
                        </p>
                        <p className="octo-para sub-heading-m-t-15 sub-heading-m-b-15">An Escort Guard requires special skills as the threat in this case is different than faced by a security guard stationed at office, factory or malls, as he is required to guard female employees at night while in transit.
                        </p>

                        <h3 className="sub-heading-page sub-heading-m-t-15 sub-heading-m-b-15"><strong>Escort Guard Training
                        </strong></h3>
                        <p className="octo-para" style={{ marginTop: '18px' }}>
                            An Escort Guard in India, Pune, Hyderabad or Bangalore becomes more potent when training is provided to them on regular basis. Training of escort security is of paramount importance and hence we provide regular training as they must deal with situation such as:
                        </p>
                        <ul class="list">
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Vehicle break down</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Miscreants/anti-social elements chasing the vehicle or trying to stop it</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Vehicle catches fire</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Unprofessional behavior of driver</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Driver taking unfamiliar route</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Employee request to change drop point or the route</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Employee faces any emergency health issue</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Riot or civil disturbance</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Roads closed due to heavy rain</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Ventilation issue caused by jammed windows and doors during flooding
                                Facing any other emergency</li>
                        </ul>

                        <p className="octo-para sub-heading-m-t-15 sub-heading-m-b-15">Our escort guards are further trained in first aid, fire fighting and self-defence on regular basis to enable them to tackle any emergency that may arise while escorting female employees at night. Our exclusively designed training for escorts guards, cover all the above topics with interactive session, demonstration and role playing which are conducted once in a month in our classroom.
                        </p>

                    
                    </div>
                </div>
            </section >


        </>
    )
}

export default Escortguard;
